import { useMutation, useQueryClient } from "@tanstack/react-query";
import { syncGoogleReviews } from "../../api/bReviewsApi";

export function useSyncGoogleReviews() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["sync-google-reviews"],
    mutationFn: syncGoogleReviews,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dashboard-stats"] });
      queryClient.invalidateQueries({ queryKey: ["reviews-list"] });
      queryClient.invalidateQueries({ queryKey: ["earliest-review-date"] });
    },
  });
}
